export default "__VITE_ASSET__DVDmIM98__"